function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "heart",
  display: "none"
}, /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  d: "M13.751,5.708C4.8,5.708,2.383,16.293,7.61,26.224 c4.835,9.187,13.721,13.068,13.721,13.068s8.885-3.882,13.721-13.068c5.227-9.931,2.809-20.516-6.142-20.516 c-4.77,0-7.579,4.312-7.579,4.312S18.521,5.708,13.751,5.708z"
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "21.331,11.719 15.908,6.034 11.138,10.936 5.519,11.85 8.852,17.207 6.238,23.088  12.118,25.243 11.465,31.646 18.063,32.431 21.396,39.226  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "21.331,11.654 16.104,12.765 11.138,10.936 10.877,14.463 12.641,19.363  17.149,26.942 21.331,30.667  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 9.57,
  y1: 6.623,
  x2: 11.073,
  y2: 10.936
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "21.331,13.875 16.169,12.765 10.877,14.463 8.852,17.207 5.062,18.449  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "8.917,17.143 12.706,19.429 12.184,25.243 8.394,27.399  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "12.184,25.243 17.149,26.942 18.194,32.496 15.385,35.371  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 18.194,
  y1: 32.431,
  x2: 21.331,
  y2: 30.797
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "21.331,11.719 26.754,6.034 31.523,10.936 37.142,11.85 33.81,17.207  36.423,23.088 30.543,25.243 31.196,31.646 24.597,32.431 21.265,39.226  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "21.331,11.654 26.558,12.765 31.523,10.936 31.784,14.463 30.021,19.363  25.512,26.942 21.331,30.667  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 33.091,
  y1: 6.623,
  x2: 31.588,
  y2: 10.936
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "21.331,13.875 26.492,12.765 31.784,14.463 33.81,17.207 37.599,18.449  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "33.744,17.143 29.955,19.429 30.478,25.243 34.267,27.399  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "30.478,25.243 25.512,26.942 24.466,32.496 27.276,35.371  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 24.466,
  y1: 32.431,
  x2: 21.331,
  y2: 30.797
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 21.331,
  y1: 9.987,
  x2: 21.331,
  y2: 13.875
})), /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  d: "M51.091,5.708 c-8.952,0-11.369,10.585-6.142,20.516C49.784,35.41,58.67,39.292,58.67,39.292s8.885-3.882,13.721-13.068 c5.227-9.931,2.809-20.516-6.143-20.516c-4.77,0-7.578,4.312-7.578,4.312S55.859,5.708,51.091,5.708z"
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "58.67,11.719 53.247,6.034 48.477,10.936 42.857,11.85 46.19,17.207  43.576,23.088 49.457,25.243 48.804,31.646 55.402,32.431 58.734,39.226  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "58.67,11.654 53.442,12.765 48.477,10.936 48.216,14.463 49.979,19.363  54.488,26.942 58.67,30.667  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 46.909,
  y1: 6.623,
  x2: 48.412,
  y2: 10.936
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "58.67,13.875 53.508,12.765 48.216,14.463 46.19,17.207 42.4,18.449  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "46.256,17.143 50.045,19.429 49.522,25.243 45.732,27.399  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "49.522,25.243 54.488,26.942 55.533,32.496 52.724,35.371  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 55.533,
  y1: 32.431,
  x2: 58.67,
  y2: 30.797
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "58.67,11.719 64.093,6.034 68.861,10.936 74.48,11.85 71.148,17.207  73.762,23.088 67.882,25.243 68.535,31.646 61.936,32.431 58.604,39.226  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "58.67,11.654 63.896,12.765 68.861,10.936 69.123,14.463 67.359,19.363  62.851,26.942 58.67,30.667  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 70.43,
  y1: 6.623,
  x2: 68.928,
  y2: 10.936
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "58.67,13.875 63.831,12.765 69.123,14.463 71.148,17.207 74.938,18.449  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "71.083,17.143 67.294,19.429 67.816,25.243 71.605,27.399  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "67.816,25.243 62.851,26.942 61.806,32.496 64.615,35.371  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 61.806,
  y1: 32.431,
  x2: 58.67,
  y2: 30.797
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 58.67,
  y1: 9.987,
  x2: 58.67,
  y2: 13.875
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "tiangle",
  display: "none"
}, /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "20.825,32.005 11.697,31.299 15.865,22.088 20.825,14.761  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "20.813,14.761 17.986,11.793 15.867,10.026  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 20.806,
  y1: 5.574,
  x2: 17.986,
  y2: 11.793
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "17.986,11.793 15.726,22.11 7.881,29.956  9.719,19.072  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "11.697,31.299 7.881,29.956 5.125,29.461  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "11.697,31.299 10.778,35.326 10.284,38.436  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "20.813,39.426 10.778,35.326 20.813,32.005  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "10.778,35.326 3.854,36.175 7.881,29.956  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "20.806,32.005 29.934,31.299 25.766,22.088 20.806,14.761  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "20.817,14.761 23.644,11.793 25.764,10.026  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 20.825,
  y1: 5.574,
  x2: 23.644,
  y2: 11.793
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "23.644,11.793 25.905,22.11  33.749,29.956 31.912,19.072  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "29.934,31.299 33.749,29.956 36.506,29.461  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "29.934,31.299 30.853,35.326 31.347,38.436  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "20.817,39.426 30.853,35.326 20.817,32.005  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "30.853,35.326 37.777,36.175 33.749,29.956  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "20.806,5.574 15.867,10.026 9.719,19.072  5.125,29.461 3.854,36.175 10.284,38.436 20.813,39.426 31.347,38.436 37.777,36.175 36.506,29.461 31.912,19.072 25.764,10.026  "
})), /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "59.193,32.005 50.065,31.299 54.233,22.088 59.193,14.761  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "59.182,14.761 56.355,11.793 54.235,10.026  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 59.174,
  y1: 5.574,
  x2: 56.355,
  y2: 11.793
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "56.355,11.793 54.095,22.11 46.25,29.956  48.088,19.072  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "50.065,31.299 46.25,29.956 43.494,29.461  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "50.065,31.299 49.147,35.326 48.652,38.436  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "59.182,39.426 49.147,35.326 59.182,32.005  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "49.147,35.326 42.222,36.175 46.25,29.956  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "59.174,32.005 68.302,31.299 64.135,22.088 59.174,14.761  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "59.186,14.761 62.013,11.793 64.133,10.026  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 59.193,
  y1: 5.574,
  x2: 62.013,
  y2: 11.793
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "62.013,11.793 64.274,22.11  72.118,29.956 70.281,19.072  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "68.302,31.299 72.118,29.956 74.874,29.461  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "68.302,31.299 69.221,35.326 69.716,38.436  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "59.186,39.426 69.221,35.326 59.186,32.005  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "69.221,35.326 76.146,36.175 72.118,29.956  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "59.174,5.574 54.235,10.026  48.088,19.072 43.494,29.461 42.222,36.175 48.652,38.436 59.182,39.426 69.716,38.436 76.146,36.175 74.874,29.461  70.281,19.072 64.133,10.026  "
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "baguette"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "18.607,41.777 37.689,41.777 33.58,3.223  22.9,3.223  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "22.246,38.362 34.06,38.362 30.773,6.633  25.861,6.633  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 37.66,
  y1: 41.755,
  x2: 34.027,
  y2: 38.332
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 18.611,
  y1: 41.755,
  x2: 22.263,
  y2: 38.332
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 22.9,
  y1: 3.223,
  x2: 25.851,
  y2: 6.66
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 33.544,
  y1: 3.251,
  x2: 30.714,
  y2: 6.66
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "shield",
  display: "none"
}, /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 9.262,
  y1: 14.182,
  x2: 2.978,
  y2: 11.604
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 11.637,
  y1: 21.925,
  x2: 6.98,
  y2: 24.033
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 16.037,
  y1: 28.172,
  x2: 13.118,
  y2: 33.512
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 13.75,
  y1: 9.694,
  x2: 10.316,
  y2: 4.239
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "20.365,40.761 13.132,33.539 6.973,24.036 2.969,11.586 10.316,4.239  20.347,4.239 20.4,4.239 30.431,4.239 37.777,11.586 33.774,24.036 27.615,33.539 20.382,40.761 20.392,32.746 24.71,28.172  29.109,21.925 31.485,14.182 26.998,9.694 20.398,9.694 20.348,9.694 13.75,9.694 9.262,14.182 11.637,21.925 16.037,28.172  20.355,32.746  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "20.392,36.395 26.174,30.86 31.397,22.98 34.677,12.887 28.559,7.231  20.398,7.231 20.348,7.231 12.188,7.231 6.07,12.887 9.35,22.98 14.572,30.86 20.355,36.395  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 31.485,
  y1: 14.182,
  x2: 37.77,
  y2: 11.604
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 29.109,
  y1: 21.925,
  x2: 33.768,
  y2: 24.033
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 24.71,
  y1: 28.172,
  x2: 27.63,
  y2: 33.512
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 26.998,
  y1: 9.694,
  x2: 30.431,
  y2: 4.239
})), /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 48.515,
  y1: 14.182,
  x2: 42.229,
  y2: 11.604
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 50.89,
  y1: 21.925,
  x2: 46.233,
  y2: 24.033
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 55.29,
  y1: 28.172,
  x2: 52.37,
  y2: 33.512
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 53.003,
  y1: 9.694,
  x2: 49.569,
  y2: 4.239
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "59.618,40.761 52.386,33.539 46.226,24.036 42.222,11.586 49.569,4.239  59.599,4.239 59.653,4.239 69.683,4.239 77.03,11.586 73.026,24.036 66.868,33.539 59.636,40.761 59.644,32.746 63.964,28.172  68.362,21.925 70.737,14.182 66.251,9.694 59.651,9.694 59.601,9.694 53.003,9.694 48.515,14.182 50.89,21.925 55.29,28.172  59.608,32.746  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "59.644,36.395 65.427,30.86 70.651,22.98 73.931,12.887 67.812,7.231  59.651,7.231 59.601,7.231 51.44,7.231 45.323,12.887 48.603,22.98 53.825,30.86 59.608,36.395  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 70.737,
  y1: 14.182,
  x2: 77.022,
  y2: 11.604
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 68.362,
  y1: 21.925,
  x2: 73.021,
  y2: 24.033
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 63.964,
  y1: 28.172,
  x2: 66.884,
  y2: 33.512
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 66.251,
  y1: 9.694,
  x2: 69.683,
  y2: 4.239
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "halfmoon",
  display: "none"
}, /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  d: "M34.203,3.919c1.17,0,2.316,0.104,3.428,0.304l-0.002,36.556 c-1.111,0.2-2.256,0.304-3.425,0.304c-10.463,0-18.945-8.319-18.945-18.582C15.258,12.238,23.74,3.919,34.203,3.919z"
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "15.339,22.5 19.702,29.044 16.955,30.176  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "22.206,22.5 19.621,29.044 24.064,31.549  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "31.901,22.5 31.901,33.73 34.163,36.234  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "37.556,22.5 34.163,36.153 37.556,40.678  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "20.268,35.266 19.621,29.044  24.064,31.549 25.68,36.396  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "31.901,33.811 27.942,35.427  24.064,31.549  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "34.163,36.153 27.942,35.427  25.68,36.396 32.305,41.082  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 25.68,
  y1: 36.315,
  x2: 25.519,
  y2: 39.062
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "15.339,22.5 19.702,15.956 16.955,14.825  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "22.206,22.5 19.621,15.956 24.064,13.452  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "31.901,22.5 31.901,11.271 34.163,8.767  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "37.556,22.5 34.163,8.847 37.556,4.323  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "20.268,9.736 19.621,15.956  24.064,13.452 25.68,8.604  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "31.901,11.189 27.942,9.574  24.064,13.452  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "34.163,8.847 27.942,9.574 25.68,8.604  32.305,3.919  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 25.68,
  y1: 8.686,
  x2: 25.519,
  y2: 5.939
})), /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  d: "M45.798,41.082c-1.17,0-2.316-0.104-3.428-0.305l0.002-36.557 c1.111-0.199,2.256-0.303,3.426-0.303c10.463,0,18.943,8.319,18.943,18.581C64.741,32.762,56.261,41.082,45.798,41.082z"
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "64.661,22.499 60.3,15.955 63.046,14.824  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "57.794,22.499 60.38,15.955  55.937,13.451  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "48.099,22.499 48.099,11.271  45.839,8.766  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "42.444,22.499 45.839,8.847 42.444,4.322  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "59.733,9.734 60.38,15.955 55.937,13.451  54.321,8.604  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "48.099,11.189 52.058,9.573  55.937,13.451  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "45.839,8.847 52.058,9.573 54.321,8.604  47.696,3.918  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 54.321,
  y1: 8.685,
  x2: 54.481,
  y2: 5.938
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "64.661,22.499 60.3,29.044 63.046,30.176  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "57.794,22.499 60.38,29.044  55.937,31.549  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "48.099,22.499 48.099,33.73  45.839,36.234  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "42.444,22.499 45.839,36.153 42.444,40.677  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "59.733,35.265 60.38,29.044  55.937,31.549 54.321,36.396  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "48.099,33.811 52.058,35.426  55.937,31.549  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "45.839,36.153 52.058,35.426  54.321,36.396 47.696,41.082  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  x1: 54.321,
  y1: 36.315,
  x2: 54.481,
  y2: 39.062
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "trapezoid",
  display: "none"
}, /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "17.327,36.634 17.327,8.367 37.487,2.5  37.487,42.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "19.097,34.043 21.896,34.051  20.743,36.575 17.943,36.567  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "34.865,40.71 34.01,37.464 36.606,38.86  37.377,42.191  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "34.064,37.408 28.072,36.963 21.951,33.995  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "20.745,36.573 34.788,40.654  28.184,37.074  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "19.097,10.908 21.896,10.899  20.743,8.375 17.943,8.383  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "34.865,4.24 34.01,7.486 36.606,6.089  37.377,2.758  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "34.064,7.542 28.072,7.986 21.951,10.955  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "20.745,8.376 34.788,4.295 28.184,7.875  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "21.951,10.955 20.421,22.503 19.033,10.983 19.034,33.967 20.421,22.447  21.951,33.995  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "34.064,37.353 35.225,22.475 36.606,38.836 36.606,6.113 35.225,22.475  34.064,7.597  "
})), /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "62.673,8.367 62.673,36.634 42.512,42.5  42.512,2.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "60.902,10.958 58.104,10.95 59.257,8.425  62.056,8.433  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "45.135,4.291 45.99,7.537 43.393,6.14  42.622,2.809  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "45.935,7.593 51.927,8.037 58.049,11.006  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "59.254,8.427 45.212,4.346 51.815,7.926  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "60.902,34.093 58.104,34.101  59.257,36.626 62.056,36.618  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "45.135,40.761 45.99,37.514  43.393,38.911 42.622,42.242  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "45.935,37.458 51.927,37.014 58.049,34.045  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "59.254,36.624 45.212,40.705  51.815,37.125  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "58.049,34.045 59.579,22.498 60.966,34.018 60.966,11.033 59.579,22.553  58.049,11.006  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  points: "45.935,7.647 44.775,22.525 43.393,6.164 43.393,38.887 44.775,22.525  45.935,37.402  "
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "kite",
  display: "none"
}, /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "21.651,4.153 5.853,17.59 21.578,40.847  37.524,17.442  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "21.651,4.153 5.853,17.59 21.578,40.847  37.524,17.442  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "SVGID_1_",
  points: "21.651,4.153 5.853,17.59 21.578,40.847 37.524,17.442  "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_2_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_1_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("line", {
  clipPath: "url(#SVGID_2_)",
  fill: "none",
  stroke: "#000000",
  x1: 21.65,
  y1: 4.162,
  x2: 21.65,
  y2: 40.996
}), /*#__PURE__*/React.createElement("line", {
  clipPath: "url(#SVGID_2_)",
  fill: "none",
  stroke: "#000000",
  x1: 5.745,
  y1: 17.559,
  x2: 37.555,
  y2: 17.559
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_1_",
  overflow: "visible",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000"
})), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "35.287,17.162 21.583,37.275  8.078,17.303 21.66,5.753  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "21.588,34.293 10.306,17.607  21.668,7.943 33.049,17.472  "
})), /*#__PURE__*/React.createElement("g", {
  display: "inline"
}, /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "58.274,4.153 42.476,17.59 58.201,40.847  74.147,17.442  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "58.274,4.153 42.476,17.59 58.201,40.847  74.147,17.442  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "SVGID_3_",
  points: "58.274,4.153 42.476,17.59 58.201,40.847 74.147,17.442  "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_4_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_3_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("line", {
  clipPath: "url(#SVGID_4_)",
  fill: "none",
  stroke: "#000000",
  x1: 58.273,
  y1: 4.162,
  x2: 58.273,
  y2: 40.996
}), /*#__PURE__*/React.createElement("line", {
  clipPath: "url(#SVGID_4_)",
  fill: "none",
  stroke: "#000000",
  x1: 42.368,
  y1: 17.559,
  x2: 74.178,
  y2: 17.559
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_3_",
  overflow: "visible",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000"
})), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "71.91,17.162 58.206,37.275  44.701,17.303 58.283,5.753  "
}), /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  stroke: "#000000",
  points: "58.211,34.293 46.929,17.607  58.291,7.943 69.673,17.472  "
})));

const SvgBaguette = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  width: "80px",
  height: "45px",
  viewBox: "29 0 1 45",
  enableBackground: "new 0 0 80 45",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBaguette, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/baguette.c11fdce3.svg";
export { ForwardRef as ReactComponent };